import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoginInfoService {
  currentUserStep = '';
  userId = '';
  clienId = '';
  pinCode = '';
  tokenHash = '';
  isClient = true;
  portalId = '';
  email = '';
  profiles: any[] = [];
}
